var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"d-none d-lg-flex",attrs:{"md":"5","lg":"4","xl":"3"}},[_c('b-card',{staticClass:"sidebar w-100"},[_c('ProfileSidebar')],1)],1),_c('b-col',[_c('router-view')],1)],1)],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }